import API from "../../../../global/api";
import { isEmpty } from 'lodash';
import { handleNoDataVisible, PDFHeader } from "../../../../global/globalFunctions";
import jsPDF from "jspdf";
import moment from "moment";


const permissions = JSON.parse(window.localStorage.getItem("permissions"))
const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? true : false
}


// POS ACTIONS
export const requestAddOrders = () => {
    return {
        type: "REQUEST_ADD_ORDERS",
    };
};
export const successAddOrders = (data) => {
    return {
        type: "SUCCESS_ADD_ORDERS",
        payload: data,
    };
};
export const errorAddOrders = () => {
    return {
        type: "ERROR_ADD_ORDERS",
    };
};
export const AddOrderApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddOrders());
        API.post(`/orders`, data).then((res) => {
            const resData = res.data
            dispatch(successAddOrders(data));
            handleVisible(res.data.message);
            if (data.isPrint == 1) {
                Checkpermissions("permissionsCatName", "Enable PDF Recipt Print") && OrderRecipt(resData);
            }
        }).catch((error) => {
            dispatch(errorAddOrders());
            handleDangerVisible(isEmpty(error.response.data) ? "Server Error" : error.response.data.message);
        })
    };
};
export const OrderRecipt = (resData) => {
    const pdfData = resData.item;
    // const pdfDataCus = resData.item.customer;
    const unit = "pt";
    const size = 'A4';
    const orientation = "p";
    const doc = new jsPDF(orientation, unit, size);
    var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();


    // const title = `Order ${pdfData.number}`;
    const companyName = `${resData.resImage.restaurantName}`;
    const companyAddress = `${resData.resImage.restaurantLocation}`;
    const companyNtn = `${resData.resImage.ntn}`;
    // const logo1 = resData.restaurantImage;
    // doc.addImage(logo1, "PNG", 1, 1, 70, 20);
    doc.setFontSize(14);
    doc.setFont("TimesNewRoman", "Normal");
    doc.setFont(undefined, "bold");
    doc.text(companyName, pageWidth / 2, 40, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.setFont("TimesNewRoman", "Normal");
    doc.text(companyAddress, pageWidth / 2, 60, { align: 'center' });
    doc.text(companyNtn, pageWidth / 2, 80, { align: 'center' });
    // doc.setFontSize(12);
    // doc.setFont("TimesNewRoman", "Normal");
    // doc.text(title, 260, 70, 0, 0);
    doc.text(`Order Date : ${pdfData.orderDate}`, 44, 100)
    doc.text(`Order No : ${pdfData.number}`, 44, 120)

    const columnTitles = [
        { title: 'Sr' },
        { title: "Product Name" },
        { title: "Product Price" },
        { title: "Product Quantity" },
        { title: "Product Total" },
    ];
    const itemData = pdfData.items.map((columnDef, index) => [
        index + 1,
        columnDef.productLabel,
        columnDef.productSellingPrice,
        columnDef.quantity,
        columnDef.productTotalAmount,
    ]);
    let content = {
        startY: 140,
        startX: 5,
        head: [columnTitles],
        body: itemData,
    };
    doc.setFont("TimesNewRoman", "Normal");
    doc.autoTable(content)
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.setFont("TimesNewRoman", "Normal");
    doc.text(`Sub Total : ${pdfData.subTotal}`, 400, doc.lastAutoTable.finalY + 20)
    doc.text(`Discount : ${pdfData.discount}`, 400, doc.lastAutoTable.finalY + 40)
    doc.text(`Tax : ${pdfData.tax}`, 400, doc.lastAutoTable.finalY + 60)
    doc.text(`Grand Total : ${pdfData.grandTotal}`, 400, doc.lastAutoTable.finalY + 80)
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.setFont("TimesNewRoman", "Normal");
    doc.text(`Thanks For Visiting At "${companyName}"`, 44, doc.lastAutoTable.finalY + 60)
    doc.text(`Powerd By ReportERP`, 44, doc.lastAutoTable.finalY + 80)


    doc.setProperties({ title: `Recipt Order ${pdfData.number}` });
    // doc.autoPrint();
    doc.output('dataurlnewwindow');
};


export const OrderDetailsPrintPDF = (orderDetails) => {
    const unit = "pt";
    const size = "A4";
    const orientation = "p";
    const doc = new jsPDF(orientation, unit, size);
    PDFHeader(doc, "Order Details");




    doc.setProperties(`Order Print ${moment().format("YYYY-MM-DD")}`);
    var blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
};


export const requestGetTodayOrders = () => {
    return {
        type: "REQUEST_GET_TODAY_ORDERS",
    };
};
export const successGetTodayOrders = (data) => {
    return {
        type: "SUCCESS_GET_TODAY_ORDERS",
        payload: data,
    };
};
export const errorGetTodayOrders = () => {
    return {
        type: "ERROR_GET_TODAY_ORDERS",
    };
};
export const getTodayOrders = () => {
    return (dispatch) => {
        dispatch(requestGetTodayOrders());
        API.get(`/orders/get_dayopen_orders`).then((res) => {
            let data1 = res.data;
            console.log(data1, 'list1');
            dispatch(successGetTodayOrders(data1));
        }).catch((error) => {
            dispatch(errorGetTodayOrders());
        })
    };
};


export const requestOrderCancel = () => {
    return {
        type: "REQUEST_ORDER_CANCEL",
    };
};
export const successOrderCancel = (data) => {
    return {
        type: "SUCCESS_ORDER_CANCEL",
        payload: data,
    };
};
export const errorOrderCancel = () => {
    return {
        type: "ERROR_ORDER_CANCEL",
    };
}
export const OrderCancelApi = (orderId, data) => {
    return dispatch => {
        dispatch(requestOrderCancel());
        API.post(`/orders/order_cancelled/${orderId}`, data).then(res => {
            dispatch(getTodayOrders());
            dispatch(successOrderCancel(orderId))
        }).catch((error) =>
            dispatch(errorOrderCancel())
        );
    }
};


// KDS ACTIONS
export const requestGetPendingOrder = () => {
    return {
        type: "REQUEST_GET_PENDING_ORDER",
    };
};
export const successGetPendingOrder = (data) => {
    return {
        type: "SUCCESS_GET_PENDING_ORDER",
        payload: data,
    };
};
export const errorGetPendingOrder = () => {
    return {
        type: "ERROR_GET_PENDING_ORDER",
    };
};
export const getPendingOrder = () => {
    return (dispatch) => {
        dispatch(requestGetPendingOrder());
        API.get(`/orders/get_pending_orders?page=0&limit=1000`)
            .then((res) => {
                let data = res.data;
                dispatch(successGetPendingOrder(data));
            }).catch((error) => {
                dispatch(errorGetPendingOrder());
            });
    };
};


export const UpdateRequestStatus = () => {
    return {
        type: "UPDATE_REQUEST_STATUS",
    };
};
export const UpdateSuccessStatus = (data) => {
    return {
        type: "UPDATE_SUCCESS_STATUS",
        payload: data,
    };
};
export const UpdateErrorStatus = () => {
    return {
        type: "UPDATE_ERROR_STATUS",
    };
};
export const updateStatus = (data, status, taxAmount, afterTaxTotalAmount, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(UpdateRequestStatus());
        API.post(`/orders/update_order_status`, {
            _id: data._id,
            status: status,
            tax: taxAmount,
            grandTotal: afterTaxTotalAmount
        }, {}).then((res) => {
            dispatch(UpdateSuccessStatus([data]));
            handleVisible();
        }).catch((error) => {
            dispatch(UpdateErrorStatus());
            handleDangerVisible();
        })
    };
};


export const filterOrderKds = (data) => {
    return {
        type: "FILTER_ORDER",
        payload: data
    };
};
export const filterOrderByTableKds = (data) => {
    return {
        type: "FILTER_ORDER_BY_TABLE",
        payload: data
    };
};